import { axiosInstance } from "../../../axios/axiosInstance";

const API_SEARCH_PERSON_URL = "organization/customers/search";
const API_GET_TERMS_AND_CONDITIONS_URL = "policy/all";
const API_ACCEPT_TERMS_AND_CONDITIONS_URL = "auth/accept-user-terms";
const API_UPDATE_KEY_VALUE_SYSTEM_SETTINGS_URL =
  "admin/system-settings/update_key_value";
const API_PAY_FINE_URL = "organization/user-management/pay-fine-organization";
const API_FINE_TRANSACTION_HISTORY_URL =
  "admin/account-renewal-payment-transactions/list";
const API_CHECK_SPONSORSHIP_AVAILABILITY_URL =
  "organization/offers/check_sponsorship";
const API_APPOINTMENT_INVOICE_URL = "organization/orders/download-invoice"
const API_CREATE_SUPPORT_TICKET_URL = "support-tickets/create"

// Notifications API
const GET_LATEST_NOTIFICATION = "notifications/latest";

const MARK_NOTIFICATION = "notifications/markAsRead";

const DELETE_ACCOUNT_URL = "/auth/delete-account";

export const searchPerson = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SEARCH_PERSON_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&searchByUsername=${dataToBeSent?.searchByUsername || ""}`
  );
};

export const getTermsAndConditions = () => {
  return axiosInstance.get(`${API_GET_TERMS_AND_CONDITIONS_URL}`);
};

export const acceptTermsAndConditions = () => {
  return axiosInstance.get(`${API_ACCEPT_TERMS_AND_CONDITIONS_URL}`);
};

export const updateKeyValue = (dataToBeSent) => {
  return axiosInstance.post(
    `${API_UPDATE_KEY_VALUE_SYSTEM_SETTINGS_URL}`,
    dataToBeSent
  );
};

export const payFine = (dataToBeSent) => {
  return axiosInstance.post(`${API_PAY_FINE_URL}`, dataToBeSent);
};

export const getFineTransactionHistory = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_FINE_TRANSACTION_HISTORY_URL}?search=${dataToBeSent?.search || ""}&page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}`
  );
};

export const getLatestNotifications = (dataToBeSent) => {
  return axiosInstance.get(`${GET_LATEST_NOTIFICATION}`);
};

export const markNotification = (dataToBeSent) => {
  return axiosInstance.post(`${MARK_NOTIFICATION}`, dataToBeSent);
};

export const checkSponsorship = (dataToBeSent) => {
  return axiosInstance.post(
    `${API_CHECK_SPONSORSHIP_AVAILABILITY_URL}`,
    dataToBeSent
  );
};

export const deleteAccount = (dataToBeSent) => {
  return axiosInstance.post(`${DELETE_ACCOUNT_URL}`, dataToBeSent);
};

export const downloadCustomerAppointmentPdf = (dataToBeSent) => {
  return axiosInstance.get(`${API_APPOINTMENT_INVOICE_URL}/${dataToBeSent?._id}`);
};


export const createServiceProviderSupportTicket = (formData) => {
  return axiosInstance.postForm(API_CREATE_SUPPORT_TICKET_URL, formData);
};